import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PublicHeader } from "@/components/PublicHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { CheckCircle2, XCircle, Loader2, FileSignature } from "lucide-react";

/** Página pública: confere se um contrato assinado é autêntico pelo código impresso no PDF. */
export default function ValidateContract() {
  const { code: codeUrl } = useParams();
  const navigate = useNavigate();
  const [code, setCode] = useState(codeUrl || "");
  const [res, setRes] = useState(null);
  const [state, setState] = useState(codeUrl ? "loading" : "idle");

  const check = (c) => {
    const v = (c ?? code).trim().toUpperCase(); if (!v) return;
    setState("loading");
    api.get(`/public/contract/${encodeURIComponent(v)}`).then((r) => { setRes(r.data); setState("ok"); }).catch(() => { setRes(null); setState("error"); });
  };
  useEffect(() => { if (codeUrl) check(codeUrl); }, [codeUrl]); // eslint-disable-line react-hooks/exhaustive-deps
  const quando = res?.signed_at ? new Date(res.signed_at).toLocaleString("pt-BR") : "";

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <PublicHeader />
      <main className="max-w-xl mx-auto px-5 py-14">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8">
          <h1 className="font-display text-2xl font-bold text-slate-900 flex items-center gap-2"><FileSignature className="h-6 w-6 text-[#1E9E2A]" /> Validar contrato assinado</h1>
          <p className="text-slate-500 text-sm mt-1.5">Digite o código que aparece na última página do contrato (ou leia o QR Code do PDF).</p>
          <div className="flex gap-2 mt-5">
            <Input value={code} onChange={(e) => setCode(e.target.value)} onKeyDown={(e) => e.key === "Enter" && navigate(`/validar-contrato/${code.trim()}`)} placeholder="IEP-CT-XXXXXXXX" className="font-mono" data-testid="validate-contract-input" />
            <Button className="text-white" style={{ background: "#232D4F" }} onClick={() => navigate(`/validar-contrato/${code.trim()}`)}>Validar</Button>
          </div>
          {state === "loading" && <div className="mt-6 grid place-items-center"><Loader2 className="h-5 w-5 animate-spin text-slate-400" /></div>}
          {state === "ok" && res && (
            <div className={`mt-6 rounded-xl border p-5 ${res.valid ? "border-green-200 bg-green-50/60" : "border-red-200 bg-red-50/60"}`} data-testid="validate-contract-result">
              <div className={`flex items-center gap-2 font-semibold ${res.valid ? "text-green-700" : "text-red-700"}`}>{res.valid ? <CheckCircle2 className="h-5 w-5" /> : <XCircle className="h-5 w-5" />} {res.valid ? "Contrato autêntico e válido" : "Contrato cancelado"}</div>
              <dl className="mt-4 space-y-2 text-sm">
                <Linha k="Assinado por" v={res.signer_name} /><Linha k="Data e hora" v={quando} /><Linha k="Versão do contrato" v={`v${res.version}`} /><Linha k="Código" v={res.code} mono />
              </dl>
              <p className="text-xs text-slate-400 mt-4 break-all">Impressão digital do arquivo (SHA-256): {res.doc_hash}</p>
            </div>
          )}
          {state === "error" && <div className="mt-6 rounded-xl border border-red-100 bg-red-50/60 p-5 flex items-center gap-3 text-red-700"><XCircle className="h-5 w-5 shrink-0" /> Contrato não encontrado. Confira o código e tente de novo.</div>}
        </div>
      </main>
    </div>
  );
}
const Linha = ({ k, v, mono }) => <div className="flex justify-between gap-4"><dt className="text-slate-500">{k}</dt><dd className={`font-medium text-slate-800 text-right ${mono ? "font-mono" : ""}`}>{v}</dd></div>;
